import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { Input } from "components/shared/FormComponents";
import CreatableSelect from "react-select/creatable";

const FaqsSeo = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [tags, setTags] = useState([]);
  const {
    reset,
    handleSubmit,
    formState: { errors },
    register,
    control,
  } = useForm();

  useEffect(() => {
    dispatch(
      getSection({
        page: "faqs",
        slug: "seo",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setTags(section.seoKeywords || []);
  }, [reset, section]);

  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    dispatch(
      editSection({
        slug: "seo",
        page: "faqs",
        data: { section: { ...data, seoKeywords: tags } },
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"seo"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={6} xs={12}>
                <Input
                  langId="seoTitle"
                  name="seoTitle.ar"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col lg={6} xs={12}>
                <Input
                  langId="seoTitle"
                  name="seoTitle.en"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6} xs={12}>
                <Input
                  langId="seoDescription"
                  name="seoDescription.ar"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col lg={6} xs={12}>
                <Input
                  langId="seoDescription"
                  name="seoDescription.en"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <div className="form-group">
                <h5>
                  <FormattedMessage id="tags" />
                </h5>
                <Controller
                  control={control}
                  name="tags"
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <CreatableSelect
                      isMulti
                      className="basic-single creatable-select"
                      classNamePrefix="select"
                      placeholder="Add Keywords"
                      onChange={(selected) => {
                        const newTags = selected.map((tag) => tag.label);
                        setTags(newTags);
                        onChange(newTags);
                      }}
                      value={tags.map((tag) => ({
                        value: tag,
                        label: tag,
                      }))}
                      options={section.seoKeywords?.map((tag) => ({
                        value: tag,
                        label: tag,
                      }))}
                    />
                  )}
                />
                <p className="error-hint">
                  {errors.tags && "Please enter some keywords"}
                </p>
              </div>
            </Row>
            <SaveChangesButton />
          </form>
        </div>
      </div>
    </div>
  );
};

export default FaqsSeo;
